import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { IWorkVistDetails } from "@/api/assignServiceProvider/assignServiceProvider.queries.type";

interface WorkVisitState {
  workVisitDetails: IWorkVistDetails | null;
  setWorkVisitDetails: (details: IWorkVistDetails | null) => void;
  clearWorkVisitDetails: () => void;
  // Helper getters
  getLocation: () => { latitude: number; longitude: number } | null;
  getTrades: () => number[] | null;
  getTradeNames: () => string[] | null;
}

export const useWorkVisitStore = create<WorkVisitState>()(
  persist(
    (set, get) => ({
      workVisitDetails: null,

      setWorkVisitDetails: (details) => set({ workVisitDetails: details }),

      clearWorkVisitDetails: () => set({ workVisitDetails: null }),

      getLocation: () => {
        const details = get().workVisitDetails;
        if (!details?.address?.latitude || !details?.address?.longitude) {
          return null;
        }
        return {
          latitude: parseFloat(details.address.latitude),
          longitude: parseFloat(details.address.longitude),
        };
      },

      getTrades: () => {
        return get().workVisitDetails?.actualWorkOrderTrades ?? null;
      },

      getTradeNames: () => {
        return get().workVisitDetails?.actualWorkOrderTradesNames ?? null;
      },
    }),
    {
      name: "work-visit-store",
      partialize: (state) => ({ workVisitDetails: state.workVisitDetails }),
    },
  ),
);
